module.exports = __webpack_public_path__ + "static/media/data5bg.dc8e89fe.jpg";